/**
 * The wire key for an actor.
 *
 * Presence hands out prefixed ids -- `u:` for members, `g:` for guests, `s:`
 * for simulated actors -- and the socket, the social state and every `to:`
 * field are written in those terms. But /api/actors/:username returns the
 * stored row, whose id is bare (`abc123`, or `guest:abc123`), so the profile
 * page holds an id that matches nothing it is compared against.
 *
 * Mirrors actorKeyOfStored in server/realtime.js. Keep the two in step: a
 * mismatch here does not throw, it silently fails to find anyone, which reads
 * as "this person is not your friend" rather than as a bug.
 */
export function actorKeyOf(actor) {
  const id = String(actor?.id ?? '');
  if (/^[ugs]:/.test(id)) return id;
  if (id.startsWith('guest:')) return `g:${id.slice('guest:'.length)}`;
  // A simulated actor's row id is an ordinary bare one — simulated_actors
  // references actors(id), so nothing about the id says which it is. The
  // server answers that with a table lookup; `kind` is how the answer reaches
  // here, and without this every simulation reads as a member who is not on
  // the globe and not your friend.
  if (actor?.kind === 'simulation') return `s:${id}`;
  return `u:${actor?.userId ?? id}`;
}
